query GetCharities(
  $page: Int
  $limit: Int
  $stringFilters: [CharityStringFilterInput!]
  $sortBy: String
) {
  charities(
    page: $page
    limit: $limit
    stringFilters: $stringFilters
    sortBy: $sortBy
  ) {
    collection {
      id
      name
      status
      charityHqCountry
      website
      notes
      fiscalYearEnd
      currency
      salesforceId
      charityCompanyNumber
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
